import ArrowRightSvg from '@/assets/ArrowRightSvg.svg';
import PensiveRobotSvg from '@/assets/PensiveRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import DialogDesktop from '@/components/dialog/DialogDesktop.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

export interface InactiveMessageProps {
  handleBack: (event: React.FormEvent) => void;
}

const InactiveMessageDesktop: React.FC<InactiveMessageProps> = ({ handleBack }) => {
  const { t } = useTranslationWithPrefix('views.errors');
  return (
    <div className="flex gap-20 mt-20 flex-1 justify-content-center w-full">
      <div className="relative flex flex-col justify-center items-center gap-20">
        <DialogDesktop
          arrow={
            <img
              alt="arrow-down"
              className="absolute -z-10 -right-11 bottom-1/4"
              src={ArrowRightSvg}
            />
          }
          content={t('inactive.subMessage')}
          message={t('inactive.title')}
        />
        <ButtonWithLoading className="align-self-md-center" onClick={handleBack}>
          {t('buttons.back')}
        </ButtonWithLoading>
      </div>
      <div style={{ maxHeight: '60vh' }}>
        <img
          alt="love-robot"
          className="w-full h-100"
          src={generateNonCachableImageSrc(PensiveRobotSvg)}
        />
      </div>
    </div>
  );
};

export default InactiveMessageDesktop;
